function Reportes() {
   return (
      <div>
         <span className='text-white'>Under Construction..!</span>
      </div>
   );
}
export default Reportes;
